module.exports = __webpack_public_path__ + "static/media/logo-ensina-by-fs-white.a64cf3d2.png";